import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { X, Mail, RefreshCw } from 'lucide-react'
import toast from 'react-hot-toast'

export function EmailVerificationBanner() {
  const [isVisible, setIsVisible] = useState(true)
  const [isResending, setIsResending] = useState(false)
  const { firebaseUser, sendEmailVerification } = useAuth()

  // Don't show if user is verified or banner is dismissed
  if (!firebaseUser || firebaseUser.emailVerified || !isVisible) {
    return null
  }

  const handleResendVerification = async () => {
    setIsResending(true)
    try {
      await sendEmailVerification()
      toast.success('Verification email sent! Check your inbox.')
    } catch (error: any) {
      console.error('Error sending verification email:', error)
      toast.error('Failed to send verification email. Please try again.')
    } finally {
      setIsResending(false)
    }
  }

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Mail className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-yellow-700">
            <strong>Please verify your email address.</strong> We've sent a verification email to{' '}
            <span className="font-medium">{firebaseUser.email}</span>. 
            Click the link in the email to verify your account.
          </p>
          <div className="mt-2">
            <button
              onClick={handleResendVerification}
              disabled={isResending}
              className="inline-flex items-center text-sm text-yellow-800 hover:text-yellow-900 font-medium disabled:opacity-50"
            >
              {isResending ? (
                <>
                  <RefreshCw className="h-4 w-4 mr-1 animate-spin" />
                  Sending...
                </>
              ) : (
                <>
                  <RefreshCw className="h-4 w-4 mr-1" />
                  Resend verification email
                </>
              )}
            </button>
          </div>
        </div>
        <div className="ml-auto pl-3">
          <button
            onClick={() => setIsVisible(false)}
            className="inline-flex text-yellow-400 hover:text-yellow-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}